import type { AddCartItemResultResponse, CartResponseResponse } from '../../../model/cart/cart';
import type { CartExpectedCredit } from '../../../model/loyalty/loyalty';
import type { Currency } from '../../../constants';
import type { CartRewardProducts } from '../../../model/cart/cartDiscovery';

export type GetCartRewardProductsRequest = GetCartRequest & { actorId?: string };
export type GetCartRewardProductsResponse = CartRewardProducts;

export type GetCartResponse = CartResponseResponse;

export type GetCartRequest = {
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type AddToCartRequest = {
  sku: string;
  quantity: number;
  /**
   * WordPress login or guest session cookie key
   */
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type AddToCartResponse = CartResponseResponse;

/**
 * Bulk add — up to 20 items, 100 units in total, applied in request order.
 *
 * No `sessionKey`: unlike `/cart/add`, this endpoint rejects unknown properties and identifies
 * the cart by `cartToken` alone.
 */
export type AddCartItemsRequest = {
  items: Array<{ sku: string; quantity: number }>;
  cartToken?: string;
  currency: Currency;
};

export type AddCartItemsResponse = CartResponseResponse & {
  /** One result per requested item, in request order. */
  results: AddCartItemResultResponse[];
};

export type UpdateCartItemRequest = {
  quantity: number;
  itemKey: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type UpdateCartItemResponse = CartResponseResponse;

export type DeleteCartRequest = {
  itemKey: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type DeleteCartResponse = CartResponseResponse;

export type ApplyCouponRequest = {
  couponCode: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type ApplyCouponResponse = CartResponseResponse;

export type RemoveCouponRequest = {
  code: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type RemoveCouponResponse = CartResponseResponse;

export type GetExpectedCreditRequest = {
  currency: Currency;
  appliedCreditAmount?: number;
};

export type GetExpectedCreditResponse = CartExpectedCredit;
